/**
 * Layout.tsx
 *
 * Layout component for the main application structure with header and routed content.
 */

import { useContext } from 'react'
import { Outlet } from 'react-router'
import ResponsiveAppBar from '../Header'
import { ROUTES } from '../route/RouteConstant'
import { ColorModeContext } from '../contexts/color-mode'

export const Layout = () => {
  const { mode } = useContext(ColorModeContext);
  // Check if current route is Customer360
  const isCustomer360 = window.location.pathname === ROUTES.CUSTOMER_360;
  const lightBackground = isCustomer360 ? "#ffffff" : "#f5f5f5";
  const darkBackground = isCustomer360 ? "#1a1a1a" : "#262626";
  const backgroundColor = mode === 'dark' ? darkBackground : lightBackground;

  return (
    <div style={{ 
      display: "flex", 
      flexDirection: "column", 
      height: "100vh",
      backgroundColor: backgroundColor 
    }}>
      <div style={{ height: "8vh" }}>
        <ResponsiveAppBar/>
      </div>
      <div style={{ 
        flex: 1, 
        overflow: "auto",
        backgroundColor: backgroundColor 
      }}>
        <Outlet/>
      </div>
    </div>
  )
}



